import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import "../../styles/mudur/VardiyaPlanlama.css";
import "../../styles/mudur/VardiyaGunlukRapor.css";
import SayfaYardimPopup from "./SayfaYardimPopup";

const bugunInputFormat = () => {
    const d = new Date();
    const yil = d.getFullYear();
    const ay = String(d.getMonth() + 1).padStart(2, "0");
    const gun = String(d.getDate()).padStart(2, "0");

    return `${yil}-${ay}-${gun}`;
};

const formatDateForApi = (date) => {
    const d = new Date(date);
    const yil = d.getFullYear();
    const ay = String(d.getMonth() + 1).padStart(2, "0");
    const gun = String(d.getDate()).padStart(2, "0");

    return `${yil}-${ay}-${gun}`;
};

const formatTarih = (value) => {
    if (!value) return "-";

    const tarih = new Date(`${String(value).substring(0, 10)}T00:00:00`);

    return tarih.toLocaleDateString("tr-TR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });
};

const gunAdiGetir = (value) => {
    if (!value) return "";

    const tarih = new Date(`${String(value).substring(0, 10)}T00:00:00`);

    return tarih.toLocaleDateString("tr-TR", {
        weekday: "long",
    });
};

const tarihDegistir = (tarih, gunFarki) => {
    const d = new Date(`${tarih}T00:00:00`);
    d.setDate(d.getDate() + gunFarki);

    return formatDateForApi(d);
};

const apiArrayGetir = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.data?.$values)) return payload.data.$values;
    if (Array.isArray(payload?.$values)) return payload.$values;
    if (Array.isArray(payload?.items)) return payload.items;
    if (Array.isArray(payload?.data?.items)) return payload.data.items;

    return [];
};

const lokasyonAdinaGoreSirala = (liste = []) => {
    return [...liste].sort((a, b) =>
        String(a.ad || "").localeCompare(String(b.ad || ""), "tr")
    );
};

const lokasyonOrgIdGetir = (lokasyon = {}) => {
    return lokasyon.organizasyonBirimiId || lokasyon.id;
};

const lokasyonunAltBirimiVarMi = (lokasyon, tumLokasyonlar = []) => {
    const orgId = lokasyonOrgIdGetir(lokasyon);

    return tumLokasyonlar.some(
        (item) => String(item.ustBirimId) === String(orgId)
    );
};

const lokasyonSelectListesiOlustur = (liste = []) => {
    const tumListe = apiArrayGetir(liste).filter(Boolean);
    const eklenenler = new Set();
    const sonuc = [];

    const ustLokasyonlar = lokasyonAdinaGoreSirala(
        tumListe.filter((lokasyon) =>
            lokasyonunAltBirimiVarMi(lokasyon, tumListe)
        )
    );

    ustLokasyonlar.forEach((ustLokasyon) => {
        const ustOrgId = lokasyonOrgIdGetir(ustLokasyon);

        sonuc.push({
            ...ustLokasyon,
            gorunenAd: `▸ ${String(ustLokasyon.ad || "").toLocaleUpperCase("tr-TR")}`,
            seviye: 0,
            anaBaslikMi: true,
        });

        eklenenler.add(String(ustLokasyon.id));

        const altLokasyonlar = lokasyonAdinaGoreSirala(
            tumListe.filter(
                (lokasyon) =>
                    String(lokasyon.ustBirimId) === String(ustOrgId) &&
                    String(lokasyon.id) !== String(ustLokasyon.id)
            )
        );

        altLokasyonlar.forEach((altLokasyon) => {
            sonuc.push({
                ...altLokasyon,
                gorunenAd: `   - ${altLokasyon.ad}`,
                seviye: 1,
                anaBaslikMi: false,
            });

            eklenenler.add(String(altLokasyon.id));
        });
    });

    const bagimsizLokasyonlar = lokasyonAdinaGoreSirala(
        tumListe.filter((lokasyon) => !eklenenler.has(String(lokasyon.id)))
    );

    bagimsizLokasyonlar.forEach((lokasyon) => {
        sonuc.push({
            ...lokasyon,
            gorunenAd: lokasyon.ad,
            seviye: 0,
            anaBaslikMi: false,
        });
    });

    return sonuc;
};

const getAvatarText = (adSoyad) => {
    if (!adSoyad) return "?";

    return adSoyad
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((x) => x[0])
        .join("")
        .toUpperCase();
};

const metinNormalize = (metin = "") => {
    return String(metin)
        .trim()
        .toLocaleLowerCase("tr-TR")
        .replace(/\s+/g, " ");
};

const getKayitId = (item = {}) => {
    return String(
        item.kullaniciId ||
        item.userId ||
        item.id ||
        item.adSoyad ||
        Math.random()
    );
};

const saatText = (value) => {
    if (!value) return "-";
    if (value === "00:00:00") return "00:00";

    return String(value).substring(0, 5);
};

const durumClassGetir = (item = {}) => {
    const durum = metinNormalize(item.durum);
    const aciklama = metinNormalize(item.durumAciklama);
    const vardiya = metinNormalize(item.atanmisVardiya);

    const girisVar =
        item.girisSaati ||
        item.baslangicSaati;

    const cikisVar =
        item.cikisSaati ||
        item.bitisSaati;

    const gecDakika = Number(item.gecKalmaDakika || 0);
    const erkenCikisDakika = Number(item.erkenCikisDakika || 0);

    if (
        durum.includes("izin") ||
        aciklama.includes("izin") ||
        vardiya.includes("izin") ||
        vardiya.includes("hi") ||
        vardiya.includes("hı")
    ) {
        return "izin";
    }

    if (
        durum.includes("gelmedi") ||
        durum.includes("devamsız") ||
        durum.includes("devamsiz") ||
        durum.includes("giriş yapmamış") ||
        durum.includes("giris yapmamis") ||
        aciklama.includes("giriş yapmamış") ||
        aciklama.includes("giris yapmamis")
    ) {
        return "gelmedi";
    }

    if (
        durum.includes("geç") ||
        durum.includes("gec") ||
        aciklama.includes("geç") ||
        aciklama.includes("gec") ||
        gecDakika > 0
    ) {
        return "gec";
    }

    if (
        durum.includes("erken") ||
        aciklama.includes("erken") ||
        erkenCikisDakika > 0
    ) {
        return "erken";
    }

    if (girisVar && !cikisVar) {
        return "aktif";
    }

    if (girisVar && cikisVar) {
        return "normal";
    }

    return "bos";
};

const durumTextGetir = (item = {}) => {
    if (item.durum && item.durum !== "-") {
        return item.durum;
    }

    const durumClass = durumClassGetir(item);

    if (durumClass === "normal") return "Normal";
    if (durumClass === "aktif") return "Aktif";
    if (durumClass === "gec") return "Geç Kaldı";
    if (durumClass === "erken") return "Erken Çıkış";
    if (durumClass === "izin") return "İzinli";
    if (durumClass === "gelmedi") return "Giriş Yok";

    return "-";
};

const vardiyaClassGetir = (item = {}) => {
    const durum = metinNormalize(item.durum);
    const vardiya = metinNormalize(item.atanmisVardiya);

    if (durum.includes("izin") || vardiya.includes("izin")) {
        return "izin";
    }

    return "";
};

const molaDetayListesiGetir = (item = {}) => {
    return apiArrayGetir(item.molaDetaylari || [])
        .filter(Boolean)
        .sort((a, b) => Number(a.sira || 0) - Number(b.sira || 0));
};

const molaSaatText = (value) => {
    if (!value) return "-";

    return String(value).substring(0, 5);
};

const molaToplamDakikaGetir = (item = {}) => {
    return (
        item.toplamGercekMolaDakika ??
        item.molaDakika ??
        item.tamamlananMolaDakika ??
        null
    );
};

const molaSureTextGetir = (mola = {}) => {
    if (mola.sureText) return mola.sureText;

    if (mola.sureDakika !== null && mola.sureDakika !== undefined) {
        return `${mola.sureDakika} dk`;
    }

    return "";
};

const dakikaText = (value) => {
    if (value === null || value === undefined || value === "") return "-";

    return `${value} dk`;
};

const saatDakikayaCevir = (value) => {
    if (!value) return null;

    const match = String(value).match(/(\d{1,2}):(\d{2})/);
    if (!match) return null;

    return Number(match[1]) * 60 + Number(match[2]);
};

const sureTextGetir = (dakika) => {
    const guvenliDakika = Math.max(Number(dakika || 0), 0);
    const saat = Math.floor(guvenliDakika / 60);
    const kalanDakika = guvenliDakika % 60;

    if (kalanDakika > 0) return `${saat} saat ${kalanDakika} dk`;
    return `${saat} saat`;
};

const vardiyaSaatleriGetir = (item = {}) => {
    let baslangic =
        item.vardiyaBaslangicSaati ||
        item.planBaslangicSaati ||
        item.planlananBaslangicSaati ||
        item.baslangicSaati;

    let bitis =
        item.vardiyaBitisSaati ||
        item.planBitisSaati ||
        item.planlananBitisSaati ||
        item.bitisSaati;

    if ((!baslangic || !bitis) && item.atanmisVardiya) {
        const match = String(item.atanmisVardiya).match(
            /(\d{1,2}:\d{2})\s*[-–]\s*(\d{1,2}:\d{2})/
        );

        if (match) {
            baslangic = match[1];
            bitis = match[2];
        }
    }

    return { baslangic, bitis };
};

const gunlukMesaiTextGetir = (item = {}) => {
    const vardiya = metinNormalize(item.atanmisVardiya);

    if (
        !item.atanmisVardiya ||
        vardiya.includes("izin") ||
        vardiya.includes("boş") ||
        vardiya.includes("bos") ||
        vardiya.includes("hafta tatili") ||
        vardiya.includes("hi") ||
        vardiya.includes("hı")
    ) {
        return "Mesai: 0 saat";
    }

    const { baslangic, bitis } = vardiyaSaatleriGetir(item);
    const baslangicDakika = saatDakikayaCevir(baslangic);
    let bitisDakika = saatDakikayaCevir(bitis);

    if (baslangicDakika === null || bitisDakika === null) {
        return "";
    }

    if (bitisDakika < baslangicDakika) {
        bitisDakika += 24 * 60;
    }

    const molaDakika = Number(
        item.planlananMolaDakika ??
        item.vardiyaMolaDakika ??
        item.molaHakkiDakika ??
        0
    );

    const netDakika = bitisDakika - baslangicDakika - molaDakika;

    return `Mesai: ${sureTextGetir(netDakika)}`;
};

const molaOzetGetir = (item = {}) => {
    const planlananDakika =
        item.planlananMolaDakika !== null &&
            item.planlananMolaDakika !== undefined
            ? item.planlananMolaDakika
            : null;

    const kullanilanDakika =
        item.toplamGercekMolaDakika ??
        item.molaDakika ??
        item.tamamlananMolaDakika ??
        null;

    const farkDakika =
        item.molaFarkDakika !== null &&
            item.molaFarkDakika !== undefined
            ? item.molaFarkDakika
            : planlananDakika !== null && kullanilanDakika !== null
                ? kullanilanDakika - planlananDakika
                : null;

    return {
        planlananDakika,
        kullanilanDakika,
        farkDakika,
        molaDurumu: item.molaDurumu || "",
        molaDurumAciklama: item.molaDurumAciklama || "",
        moladaMi: Boolean(item.moladaMi),
        molaSayisi:
            item.molaOturumSayisi !== null &&
                item.molaOturumSayisi !== undefined
                ? item.molaOturumSayisi
                : molaDetayListesiGetir(item).length,
    };
};

const molaDurumClassGetir = (molaDurumu = "") => {
    if (molaDurumu === "FazlaMola") return "fazla";
    if (molaDurumu === "AzMola") return "az";
    if (molaDurumu === "Uygun") return "uygun";
    if (molaDurumu === "PlanYok") return "plansiz";
    if (molaDurumu === "MolaPlaniYok") return "plansiz";
    if (molaDurumu === "MolaTakibiYok") return "takipsiz";

    return "";
};

const filtreTipiGetir = (key) => {
    if (!key || key === "toplamPersonel") return "";

    return key;
};

const statKartlari = [
    {
        key: "toplamPersonel",
        label: "Toplam Personel",
        icon: "👥",
        className: "cyan",
    },
    {
        key: "aktifPersonel",
        label: "Aktif Personel",
        icon: "🟢",
        className: "green",
    },
    {
        key: "girisYapanPersonel",
        label: "Giriş Yapan",
        icon: "✅",
        className: "purple",
    },
    {
        key: "girisYapmamisPersonel",
        label: "Giriş Yapmamış",
        icon: "🚫",
        className: "red",
    },
    {
        key: "gecKalanPersonel",
        label: "Geç Kalan",
        icon: "⏰",
        className: "orange",
    },
    {
        key: "izinliPersonel",
        label: "İzinli",
        icon: "🌴",
        className: "yellow",
    },
    {
        key: "moladakiPersonel",
        label: "Moladakiler",
        subLabel: "Aktif molada",
        icon: "☕",
        className: "blue",
    },
];

function VardiyaGunlukRapor() {
    const token = localStorage.getItem("token");
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const authHeader = {
        Authorization: `Bearer ${token}`,
    };

    const [tarih, setTarih] = useState(bugunInputFormat());
    const [lokasyonlar, setLokasyonlar] = useState([]);
    const [seciliLokasyonId, setSeciliLokasyonId] = useState("");
    const lokasyonSelectListesi = useMemo(() => {
        return lokasyonSelectListesiOlustur(lokasyonlar);
    }, [lokasyonlar]);
    const [kullaniciAra, setKullaniciAra] = useState("");
    const [pozisyonFiltre, setPozisyonFiltre] = useState("");
    const [tabloAra, setTabloAra] = useState("");
    const [aktifIstatistik, setAktifIstatistik] = useState("toplamPersonel");
    const [yardimAcik, setYardimAcik] = useState(false);
    const [sayfa, setSayfa] = useState(1);
    const [sayfaBoyutu, setSayfaBoyutu] = useState(10);

    const [molaDetayModal, setMolaDetayModal] = useState({
        acik: false,
        data: null,
    });

    const [gunlukKayitlar, setGunlukKayitlar] = useState([]);
    const [istatistikler, setIstatistikler] = useState({});
    const [raporLokasyon, setRaporLokasyon] = useState(null);
    const [personelFotoMap, setPersonelFotoMap] = useState({});
    const personelFotoUrlRef = useRef({});

    const [veriYukleniyor, setVeriYukleniyor] = useState(false);
    const [apiHata, setApiHata] = useState("");

    const pozisyonSecenekleri = useMemo(() => {
        const pozisyonlar = apiArrayGetir(gunlukKayitlar)
            .map((item) => item.pozisyon || item.pozisyonAdi)
            .filter((pozisyon) => pozisyon && pozisyon !== "-");

        return [...new Set(pozisyonlar)].sort((a, b) =>
            a.localeCompare(b, "tr")
        );
    }, [gunlukKayitlar]);

    const filtrelenmisKayitlar = useMemo(() => {
        const tabloQ = metinNormalize(tabloAra);
        const kullaniciQ = metinNormalize(kullaniciAra);
        const seciliPozisyon = metinNormalize(pozisyonFiltre);

        return apiArrayGetir(gunlukKayitlar).filter((item) => {
            const genelText = metinNormalize(
                [
                    item.adSoyad,
                    item.fullName,
                    item.name,
                    item.pozisyon,
                    item.pozisyonAdi,
                    item.lokasyonAdi,
                    item.grupAdi,
                    item.atanmisVardiya,
                    item.durum,
                    item.durumAciklama,
                ]
                    .filter(Boolean)
                    .join(" ")
            );

            const kullaniciText = metinNormalize(
                [
                    item.adSoyad,
                    item.fullName,
                    item.name,
                    item.pozisyon,
                    item.pozisyonAdi,
                ]
                    .filter(Boolean)
                    .join(" ")
            );

            const pozisyonText = metinNormalize(
                item.pozisyon || item.pozisyonAdi || ""
            );

            const tabloMatch = !tabloQ || genelText.includes(tabloQ);
            const kullaniciMatch =
                !kullaniciQ || kullaniciText.includes(kullaniciQ);
            const pozisyonMatch =
                !seciliPozisyon || pozisyonText === seciliPozisyon;

            return tabloMatch && kullaniciMatch && pozisyonMatch;
        });
    }, [gunlukKayitlar, tabloAra, kullaniciAra, pozisyonFiltre]);


    const toplamSayfa = useMemo(() => {
        return Math.max(1, Math.ceil(filtrelenmisKayitlar.length / sayfaBoyutu));
    }, [filtrelenmisKayitlar.length, sayfaBoyutu]);

    const sayfadakiKayitlar = useMemo(() => {
        const baslangicIndex = (sayfa - 1) * sayfaBoyutu;
        const bitisIndex = baslangicIndex + sayfaBoyutu;

        return filtrelenmisKayitlar.slice(baslangicIndex, bitisIndex);
    }, [filtrelenmisKayitlar, sayfa, sayfaBoyutu]);

    const listeBaslangic =
        filtrelenmisKayitlar.length === 0
            ? 0
            : (sayfa - 1) * sayfaBoyutu + 1;

    const listeBitis = Math.min(
        sayfa * sayfaBoyutu,
        filtrelenmisKayitlar.length
    );

    const fotoYetkisiVar = useMemo(() => {
        try {
            const raw = localStorage.getItem("permissionCodes");
            const parsed = raw ? JSON.parse(raw) : [];

            const liste = apiArrayGetir(parsed).map((x) =>
                String(x).trim().toLowerCase()
            );

            return liste.includes("vardiya.birim-personel-fotograflari.goruntule");
        } catch {
            return false;
        }
    }, []);

    const apiUrlTamamla = (url) => {
        if (!url) return "";

        if (/^https?:\/\//i.test(url)) {
            return url;
        }

        return `${apiBaseUrl}${url.startsWith("/") ? "" : "/"}${url}`;
    };

    const personelFotoKeyGetir = (personel = {}) => {
        return String(
            personel.kullaniciId ||
            personel.userId ||
            personel.id ||
            personel.adSoyad ||
            ""
        );
    };

    const personelFotoKaynakGetir = (personel = {}) => {
        const key = personelFotoKeyGetir(personel);

        return (
            personelFotoMap[key] ||
            apiUrlTamamla(
                personel.foto ||
                personel.fotoUrl ||
                personel.profilFotoUrl ||
                personel.profilePhotoUrl ||
                ""
            )
        );
    };

    const lokasyonlariGetir = async () => {
        try {
            setApiHata("");

            const res = await axios.get(
                `${apiBaseUrl}/api/Vardiya/lokasyonlar?yetki=vardiya.gunluk-rapor.goruntule`,
                {
                    headers: authHeader,
                }
            );

            console.log("Günlük rapor lokasyonları:", res.data);

            const gelenLokasyonlar = apiArrayGetir(res.data);

            setLokasyonlar(gelenLokasyonlar);

            const siraliListe = lokasyonSelectListesiOlustur(gelenLokasyonlar);

            if (siraliListe.length > 0) {
                setSeciliLokasyonId(String(siraliListe[0].id));
            }
        } catch (error) {
            console.error("Günlük rapor lokasyonları alınamadı:", error);

            setApiHata(
                error.response?.data?.message ||
                "Günlük rapor lokasyonları alınamadı."
            );
        }
    };

    const gunlukRaporGetir = async () => {
        if (!seciliLokasyonId) return;

        try {
            setVeriYukleniyor(true);
            setApiHata("");

            const params = new URLSearchParams();

            params.append("tarih", tarih);
            params.append("lokasyonId", seciliLokasyonId);

            const filtreTipi = filtreTipiGetir(aktifIstatistik);

            if (filtreTipi) {
                params.append("filtreTipi", filtreTipi);
            }

            if (kullaniciAra.trim()) {
                params.append("ara", kullaniciAra.trim());
            }

            const res = await axios.get(
                `${apiBaseUrl}/api/Vardiya/gunluk-rapor?${params.toString()}`,
                {
                    headers: authHeader,
                }
            );

            console.log("Günlük vardiya raporu:", res.data);

            const data = res.data?.data || res.data;

            setRaporLokasyon(data?.lokasyon || null);
            setIstatistikler(data?.istatistikler || {});
            setGunlukKayitlar(apiArrayGetir(data?.kayitlar).filter(Boolean));
        } catch (error) {
            console.error("Günlük rapor alınamadı:", error);

            setGunlukKayitlar([]);
            setIstatistikler({});

            setApiHata(
                error.response?.data?.message ||
                "Günlük vardiya raporu alınamadı."
            );
        } finally {
            setVeriYukleniyor(false);
        }
    };

    const buguneDon = () => {
        setTarih(bugunInputFormat());
        setTabloAra("");
    };

    const filtreleriSifirla = () => {
        setKullaniciAra("");
        setPozisyonFiltre("");
        setTabloAra("");
        setAktifIstatistik("toplamPersonel");
    };

    useEffect(() => {
        setSayfa(1);
    }, [tarih, seciliLokasyonId, aktifIstatistik, kullaniciAra, pozisyonFiltre, tabloAra, sayfaBoyutu]);

    useEffect(() => {
        if (!token || gunlukKayitlar.length === 0 || !fotoYetkisiVar) return;

        const endpointliPersoneller = apiArrayGetir(gunlukKayitlar).filter((personel) => {
            const key = personelFotoKeyGetir(personel);

            return (
                personel.profilFotoEndpoint &&
                !personelFotoUrlRef.current[key]
            );
        });

        if (endpointliPersoneller.length === 0) return;

        let iptalEdildi = false;

        const fotograflariGetir = async () => {
            const yeniFotolar = {};

            await Promise.allSettled(
                endpointliPersoneller.map(async (personel) => {
                    const key = personelFotoKeyGetir(personel);

                    const res = await axios.get(
                        apiUrlTamamla(personel.profilFotoEndpoint),
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                            responseType: "blob",
                        }
                    );

                    const objectUrl = URL.createObjectURL(res.data);

                    personelFotoUrlRef.current[key] = objectUrl;
                    yeniFotolar[key] = objectUrl;
                })
            );

            if (!iptalEdildi && Object.keys(yeniFotolar).length > 0) {
                setPersonelFotoMap((prev) => ({
                    ...prev,
                    ...yeniFotolar,
                }));
            }
        };

        fotograflariGetir();

        return () => {
            iptalEdildi = true;
        };
    }, [gunlukKayitlar, token, apiBaseUrl, fotoYetkisiVar]);

    useEffect(() => {
        return () => {
            Object.values(personelFotoUrlRef.current).forEach((url) => {
                URL.revokeObjectURL(url);
            });
        };
    }, []);

    useEffect(() => {
        if (!token) return;

        lokasyonlariGetir();
    }, [token]);

    useEffect(() => {
        if (!seciliLokasyonId) return;

        gunlukRaporGetir();
    }, [seciliLokasyonId, tarih, aktifIstatistik]);

    const gunlukRaporYardim = [
        {
            heading: "Bu sayfa ne işe yarar?",
            text: "Vardiya Günlük Rapor ekranı, seçilen mağazada o gün çalışması planlanan personellerin giriş-çıkış durumlarını takip etmek için kullanılır. Bu ekranda kim giriş yapmış, kim giriş yapmamış, kim geç kalmış veya kim izinli kolayca görülebilir.",
        },
        {
            heading: "İlk olarak ne yapmalısınız?",
            items: [
                "Önce üst bölümden kontrol etmek istediğiniz günü seçin.",
                "Lokasyon alanından doğru mağazanın seçili olduğundan emin olun.",
                "Gerekirse kullanıcı adı veya pozisyon filtresiyle listeyi daraltın.",
                "Raporu yorumlamadan önce tarih ve lokasyon bilgisini mutlaka kontrol edin.",
            ],
        },
        {
            heading: "İstatistik kartları nasıl kullanılır?",
            items: [
                "Toplam Personel, seçili gün için listelenen tüm personelleri gösterir.",
                "Giriş Yapan Personel, o gün giriş kaydı bulunan personelleri gösterir.",
                "Giriş Yapmamış Personel, vardiyası başlamış ama giriş kaydı olmayan personelleri gösterir.",
                "Geç Kalan Personel, vardiya başlangıcına göre geç giriş yapan personelleri gösterir.",
                "İzinli Personel, o gün izinli görünen personelleri gösterir.",
                "Kartlara tıklayarak tabloyu ilgili duruma göre hızlıca filtreleyebilirsiniz.",
            ],
        },
        {
            heading: "Durum alanı ne anlama gelir?",
            items: [
                "Normal, personelin giriş-çıkışında belirgin sorun olmadığını gösterir.",
                "Giriş Yapmadı, vardiyası başlamış olmasına rağmen giriş kaydı olmadığını gösterir.",
                "Eksik Çıkış, personelin giriş yaptığı ancak çıkış kaydının bulunmadığını gösterir.",
                "Geç Kaldı, personelin planlanan vardiya saatinden sonra giriş yaptığını gösterir.",
                "İzinli, personelin o gün çalışmaması gerektiğini gösterir.",
            ],
        },
        {
            heading: "Nelere dikkat etmelisiniz?",
            items: [
                "Giriş yapmamış görünen personel için önce PDKS cihazı veya kayıt sistemi kontrol edilmelidir.",
                "Eksik çıkış görünen personelde çıkış kaydı unutulmuş olabilir.",
                "Yanlış vardiya planı varsa günlük raporda durumlar da yanlış görünebilir.",
                "Personel izinli olduğu halde giriş yaptıysa ayrıca kontrol edilmelidir.",
                "Günlük rapordaki veriler puantaj kontrolü için ön bilgi olarak değerlendirilmelidir.",
            ],
        },
        {
            heading: "En sık yapılan hatalar",
            items: [
                "Yanlış tarih seçiliyken rapora bakmak.",
                "Yanlış lokasyon seçiliyken personel durumunu kontrol etmek.",
                "Giriş yapmadı bilgisini kontrol etmeden kesin devamsızlık gibi değerlendirmek.",
                "Eksik çıkış kayıtlarını PDKS kontrolü yapmadan onaylamak.",
                "Vardiya planı eksikken günlük raporu hatalı sanmak.",
            ],
        },
        {
            heading: "Kısa öneri",
            text: "Günlük kontrol yaparken önce giriş yapmayanları, sonra geç kalanları, en son da eksik çıkış kayıtlarını kontrol etmeniz daha sağlıklı olur.",
        },
    ];

    return (
        <div className="vardiya-gunluk-page">
            <section className="shift-filter-card gunluk-filter-card">
                <div className="shift-filter-head gunluk-filter-head">
                    <h2>Vardiya Günlük Rapor</h2>

                    <div className="gunluk-head-actions">
                        <button
                            type="button"
                            className="sayfa-yardim-btn"
                            onClick={() => setYardimAcik(true)}
                            title="Sayfa yardımı"
                        >
                            ?
                        </button>
                    </div>
                </div>

                <div className="shift-filter-grid">
                    <label>
                        Tarih
                        <div className="shift-week-control">
                            <button
                                type="button"
                                onClick={() => setTarih((prev) => tarihDegistir(prev, -1))}
                                title="Önceki gün"
                            >
                                ‹
                            </button>

                            <div className="shift-week-date-box">
                                <div className="shift-week-date-text">
                                    <span>{formatTarih(tarih)}</span>
                                    <small>{gunAdiGetir(tarih)}</small>
                                </div>

                                <input
                                    type="date"
                                    className="shift-date-picker-input"
                                    value={tarih}
                                    onChange={(e) => setTarih(e.target.value)}
                                    title="Tarih seç"
                                />
                            </div>

                            <button
                                type="button"
                                onClick={() => setTarih((prev) => tarihDegistir(prev, 1))}
                                title="Sonraki gün"
                            >
                                ›
                            </button>

                            <button
                                type="button"
                                className="shift-this-week-btn"
                                onClick={buguneDon}
                            >
                                Bugün
                            </button>
                        </div>
                    </label>

                    <label>
                        Lokasyon
                        <div className="shift-input-like">
                            <select
                                value={seciliLokasyonId}
                                onChange={(e) => setSeciliLokasyonId(e.target.value)}
                            >
                                <option value="">Lokasyon seçiniz</option>

                                {lokasyonSelectListesi.map((lokasyon) => (
                                    <option
                                        key={lokasyon.id}
                                        value={lokasyon.id}
                                        className={
                                            lokasyon.anaBaslikMi
                                                ? "lokasyon-ana-option"
                                                : "lokasyon-alt-option"
                                        }
                                    >
                                        {lokasyon.gorunenAd}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </label>

                    <label>
                        Kullanıcılar
                        <div className="shift-input-like">
                            <input
                                value={kullaniciAra}
                                onChange={(e) => setKullaniciAra(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        gunlukRaporGetir();
                                    }
                                }}
                                placeholder="Kullanıcı Ara"
                            />
                        </div>
                    </label>

                    <label>
                        Pozisyon
                        <div className="shift-input-like">
                            <select
                                value={pozisyonFiltre}
                                onChange={(e) => setPozisyonFiltre(e.target.value)}
                            >
                                <option value="">Tüm Pozisyonlar</option>

                                {pozisyonSecenekleri.map((pozisyon) => (
                                    <option key={pozisyon} value={pozisyon}>
                                        {pozisyon}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </label>
                </div>
            </section>

            {apiHata && (
                <div className="gunluk-api-message error">
                    {apiHata}
                </div>
            )}

            {veriYukleniyor && (
                <div className="gunluk-api-message loading">
                    Günlük rapor verileri yükleniyor...
                </div>
            )}

            <section className="gunluk-stats-card">
                <h3>İstatistikler</h3>

                <div className="gunluk-stats-grid">
                    {statKartlari.map((stat) => (
                        <button
                            type="button"
                            className={`gunluk-stat-item ${aktifIstatistik === stat.key ? "aktif" : ""
                                }`}
                            key={stat.key}
                            onClick={() => setAktifIstatistik(stat.key)}
                        >
                            <span className={`gunluk-stat-icon ${stat.className}`}>
                                {stat.icon}
                            </span>

                            <div>
                                <strong>{Number(istatistikler?.[stat.key] || 0)}</strong>
                                <p>{stat.label}</p>

                                {stat.subLabel && <small>{stat.subLabel}</small>}
                            </div>
                        </button>
                    ))}
                </div>
            </section>

            <section className="gunluk-rapor-card">

                <div className="gunluk-aktif-filtre">
                    {aktifIstatistik !== "toplamPersonel" && (
                        <button onClick={() => setAktifIstatistik("toplamPersonel")}>
                            Filtreyi Temizle
                        </button>
                    )}

                    {(kullaniciAra || pozisyonFiltre || tabloAra) && (
                        <button onClick={filtreleriSifirla}>
                            Aramaları Temizle
                        </button>
                    )}
                </div>

                <div className="gunluk-table-wrapper">
                    <table className="gunluk-rapor-table">
                        <thead>
                            <tr>
                                <th>KULLANICI</th>
                                <th>LOKASYON</th>
                                <th>ATANMIŞ VARDİYA</th>
                                <th>GİRİŞ SAATİ ↓</th>
                                <th>ÇIKIŞ SAATİ</th>
                                <th>MOLA</th>
                                <th>DURUM</th>
                            </tr>
                        </thead>

                        <tbody>
                            {sayfadakiKayitlar.map((item) => {
                                const adSoyad =
                                    item.adSoyad ||
                                    item.fullName ||
                                    item.name ||
                                    "-";

                                const pozisyon =
                                    item.pozisyon ||
                                    item.pozisyonAdi ||
                                    item.grupAdi ||
                                    "-";

                                const lokasyonAdi =
                                    item.lokasyonAdi ||
                                    raporLokasyon?.ad ||
                                    "-";

                                const durumClass = durumClassGetir(item);
                                const vardiyaClass = vardiyaClassGetir(item);
                                return (
                                    <tr key={getKayitId(item)}>
                                        <td data-label="Kullanıcı">
                                            <div className="gunluk-user-cell">
                                                {personelFotoKaynakGetir(item) ? (
                                                    <img src={personelFotoKaynakGetir(item)} alt={adSoyad} />
                                                ) : (
                                                    <div className="gunluk-avatar">{getAvatarText(adSoyad)}</div>
                                                )}

                                                <div>
                                                    <strong>{adSoyad}</strong>
                                                    <span>{pozisyon}</span>
                                                </div>
                                            </div>
                                        </td>

                                        <td data-label="Lokasyon">{lokasyonAdi}</td>

                                        <td data-label="Atanmış Vardiya">
                                            <div className="gunluk-vardiya-wrap">
                                                <span className={`gunluk-vardiya-text ${vardiyaClass}`}>
                                                    {item.atanmisVardiya || "-"}
                                                </span>

                                                {gunlukMesaiTextGetir(item) && (
                                                    <small className="gunluk-vardiya-mesai">
                                                        {gunlukMesaiTextGetir(item)}
                                                    </small>
                                                )}
                                            </div>
                                        </td>

                                        <td data-label="Giriş Saati">
                                            {saatText(item.girisSaati || item.baslangicSaati)}
                                        </td>

                                        <td data-label="Çıkış Saati">
                                            {saatText(item.cikisSaati || item.bitisSaati)}
                                        </td>

                                        <td className="gunluk-mola-cell" data-label="Mola">
                                            {(() => {
                                                const molaOzet = molaOzetGetir(item);
                                                const molaDetaylari = molaDetayListesiGetir(item);

                                                const molaBilgisiVar =
                                                    molaOzet.planlananDakika !== null ||
                                                    molaOzet.kullanilanDakika !== null ||
                                                    molaOzet.moladaMi ||
                                                    molaDetaylari.length > 0;

                                                if (!molaBilgisiVar) {
                                                    return <span>-</span>;
                                                }

                                                return (
                                                    <button
                                                        type="button"
                                                        className={`gunluk-mola-summary-btn ${molaDurumClassGetir(
                                                            molaOzet.molaDurumu
                                                        )}`}
                                                        onClick={() =>
                                                            setMolaDetayModal({
                                                                acik: true,
                                                                data: item,
                                                            })
                                                        }
                                                    >
                                                        <span>
                                                            Mola Hakkı:
                                                            <strong>{dakikaText(molaOzet.planlananDakika)}</strong>
                                                        </span>

                                                        <span className="gunluk-mola-used-row">
                                                            Kullanılan:
                                                            <strong>{dakikaText(molaOzet.kullanilanDakika)}</strong>

                                                            {molaOzet.moladaMi && (
                                                                <em className="gunluk-mola-inline-live">
                                                                    <i />
                                                                    devam ediyor
                                                                </em>
                                                            )}
                                                        </span>

                                                        {molaOzet.molaDurumAciklama && (
                                                            <small>{molaOzet.molaDurumAciklama}</small>
                                                        )}

                                                        <em className="gunluk-mola-detail-text">Detay için tıkla</em>
                                                    </button>
                                                );
                                            })()}
                                        </td>

                                        <td className="gunluk-durum-cell" data-label="Durum">
                                            <div className="gunluk-durum-wrap">
                                                <span className={`gunluk-durum ${durumClass}`}>
                                                    {durumTextGetir(item)}
                                                </span>

                                                {item.durumAciklama && item.durumAciklama !== "-" && (
                                                    <small className="gunluk-durum-aciklama">
                                                        {item.durumAciklama}
                                                    </small>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}

                            {sayfadakiKayitlar.length === 0 && (
                                <tr>
                                    <td colSpan="7" className="gunluk-empty-row">
                                        Kayıt bulunamadı.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="gunluk-rapor-footer">
                    <span>
                        Tarih: <strong>{formatTarih(tarih)}</strong>
                    </span>

                    <div className="gunluk-pagination">
                        <span>Sayfa başı:</span>

                        <select
                            value={sayfaBoyutu}
                            onChange={(e) => {
                                setSayfaBoyutu(Number(e.target.value));
                                setSayfa(1);
                            }}
                        >
                            <option value={10}>10 kişi</option>
                            <option value={30}>30 kişi</option>
                            <option value={50}>50 kişi</option>
                        </select>

                        <span>
                            {listeBaslangic}-{listeBitis} / {filtrelenmisKayitlar.length}
                        </span>

                        <button
                            type="button"
                            onClick={() => setSayfa((prev) => Math.max(1, prev - 1))}
                            disabled={sayfa <= 1}
                        >
                            ‹
                        </button>

                        <button
                            type="button"
                            onClick={() => setSayfa((prev) => Math.min(toplamSayfa, prev + 1))}
                            disabled={sayfa >= toplamSayfa}
                        >
                            ›
                        </button>
                    </div>
                </div>
            </section>

            {molaDetayModal.acik && molaDetayModal.data && (
                <div
                    className="gunluk-mola-modal-backdrop"
                    onClick={() =>
                        setMolaDetayModal({
                            acik: false,
                            data: null,
                        })
                    }
                >
                    <div
                        className="gunluk-mola-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="gunluk-mola-modal-head">
                            <div>
                                <h3>Mola Detayı</h3>
                                <span>
                                    {molaDetayModal.data.adSoyad ||
                                        molaDetayModal.data.fullName ||
                                        molaDetayModal.data.name ||
                                        "-"}
                                </span>
                            </div>

                            <button
                                type="button"
                                onClick={() =>
                                    setMolaDetayModal({
                                        acik: false,
                                        data: null,
                                    })
                                }
                            >
                                ×
                            </button>
                        </div>

                        {(() => {
                            const item = molaDetayModal.data;
                            const molaOzet = molaOzetGetir(item);
                            const molaDetaylari = molaDetayListesiGetir(item);

                            return (
                                <>
                                    <div className="gunluk-mola-modal-summary">
                                        <div>
                                            <span>Mola Hakkı</span>
                                            <strong>{dakikaText(molaOzet.planlananDakika)}</strong>
                                        </div>

                                        <div>
                                            <span>Kullanılan</span>
                                            <strong>{dakikaText(molaOzet.kullanilanDakika)}</strong>
                                        </div>

                                        <div>
                                            <span>Mola Sayısı</span>
                                            <strong>{molaOzet.molaSayisi}</strong>
                                        </div>

                                        <div>
                                            <span>Durum</span>
                                            <strong>
                                                {molaOzet.molaDurumAciklama || "-"}
                                            </strong>
                                        </div>
                                    </div>

                                    <table className="gunluk-mola-detail-table">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Başlangıç</th>
                                                <th>Bitiş</th>
                                                <th>Süre</th>
                                                <th>Durum</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {molaDetaylari.map((mola, index) => (
                                                <tr key={mola.molaOturumId || index}>
                                                    <td>{mola.sira || index + 1}</td>
                                                    <td>{molaSaatText(mola.molaBaslangicSaati)}</td>
                                                    <td>
                                                        {mola.aktifMi
                                                            ? "Devam ediyor"
                                                            : molaSaatText(mola.molaBitisSaati)}
                                                    </td>
                                                    <td>{molaSureTextGetir(mola) || dakikaText(mola.sureDakika)}</td>
                                                    <td>
                                                        {mola.aktifMi ? "Aktif mola" : "Tamamlandı"}
                                                    </td>
                                                </tr>
                                            ))}

                                            {molaDetaylari.length === 0 && (
                                                <tr>
                                                    <td colSpan="5" className="gunluk-empty-row">
                                                        Mola detayı bulunamadı.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </>
                            );
                        })()}
                    </div>
                </div>
            )}

            <SayfaYardimPopup
                open={yardimAcik}
                onClose={() => setYardimAcik(false)}
                title="Vardiya Günlük Rapor Nasıl Kullanılır?"
                sections={gunlukRaporYardim}
            />

        </div>
    );
}

export default VardiyaGunlukRapor;